// extracted by mini-css-extract-plugin
module.exports = {"container":"TabMenu_container___kUIb","menu":"TabMenu_menu__R4EO8"};